import { Checkbox, FormControlLabel } from '@mui/material';
import {
    CheckboxChecked,
    CheckboxUnchecked,
} from '@resurs-internal/mui/components/SelectCheckboxField/SelectCheckboxField';
import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { ChangeEvent, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';
import { CheckboxFieldStyles } from '../CheckboxField/Checkbox.styles';
import InputField from '../InputField/InputField';

type KycCheckboxFieldProps = {
    name: string;
    label?: string;
    required?: boolean;
    options: SelectFieldOption[];
};

const KycCheckboxField = (props: KycCheckboxFieldProps) => {
    const field = useAppSelector(selectFieldStateByName)(props.name);
    const fieldValue = useAppSelector(selectFieldStateByName)(props.name)?.value;
    const dispatch = useAppDispatch();

    useEffect(() => {
        const defaultOption = props.options?.find((option) => option.label === 'false');
        if (defaultOption && (!field || !field?.value)) {
            dispatch(
                addOrUpdateFormField({
                    fieldName: props.name,
                    label: props.label,
                    value: defaultOption.label,
                } as IFieldState),
            );
        }
    }, [props.options]);

    const preOnChange = (_event: ChangeEvent<HTMLInputElement>): void => {
        const checked = fieldValue !== 'true';
        const value = checked
            ? props.options.find((option) => option.label === 'true')?.label
            : props.options.find((option) => option.label === 'false')?.label;
        dispatch(
            addOrUpdateFormField({
                fieldName: props.name,
                label: props.label,
                value: value ?? '',
            } as IFieldState),
        );
    };

    return (
        <CheckboxFieldStyles>
            <InputField {...props}>
                <FormControlLabel
                    control={
                        <Checkbox
                            {...props}
                            checked={fieldValue === 'true'}
                            onChange={preOnChange}
                            icon={<CheckboxUnchecked />}
                            checkedIcon={<CheckboxChecked />}
                        />
                    }
                    label={props.label}
                />
            </InputField>
        </CheckboxFieldStyles>
    );
};

export default KycCheckboxField;
